import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/footer/siteFooter/SiteFooterLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/TopNavigation/TopNavigationBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/visitor-setup/Analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/sb-shell/components/visitor-setup/DatadogInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UtmCookieSetup"] */ "/app/apps/sb-shell/components/visitor-setup/UtmCookieSetup.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_b8c1a6487d58e974856145344f0bb470/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/builder/clientUtils.tsx");
